import { Directive, Input, HostListener } from '@angular/core';

import { FastReportService } from '@services/fast-report.service';
import { IReportRedirectValues } from '@interfaces/fast-report-params';

@Directive({
  selector: '[reportRedirect]',
})
export class ReportRedirectDirective {
  @Input('reportRedirect') reportValues: IReportRedirectValues;

  constructor(readonly fastReportService: FastReportService) {}

  @HostListener('click') onClick(): boolean {
    const { key, query } = this.reportValues;

    if (!this.reportValues) {
      return true;
    }

    this.fastReportService.navigate(key, query);
    return false;
  }
}
